import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

// Light theme color styles
const colorStyles = {
  Yellow: "bg-yellow-100 text-yellow-700 border-yellow-400",
  Red: "bg-red-100 text-red-700 border-red-400",
  Blue: "bg-blue-100 text-blue-700 border-blue-400",
  Green: "bg-green-100 text-green-700 border-green-400",
  "-": "bg-gray-100 text-gray-500 border-gray-300",
};

// Function to get the style for a color (handles combinations like "Yellow / Blue")
const getColorStyle = (color) => {
  if (!color || color === "-") return colorStyles["-"];
  
  // Check for exact match first
  if (colorStyles[color]) return colorStyles[color];
  
  // For combination colors, use a gradient or the first color's style
  const colorLower = color.toLowerCase();
  
  if (colorLower.includes("green") && colorLower.includes("blue")) {
    return "bg-gradient-to-r from-green-100 to-blue-100 text-green-700 border-green-400";
  }
  if (colorLower.includes("yellow") && colorLower.includes("blue")) {
    return "bg-gradient-to-r from-yellow-100 to-blue-100 text-yellow-700 border-yellow-400";
  }
  if (colorLower.includes("red") && colorLower.includes("blue")) {
    return "bg-gradient-to-r from-red-100 to-blue-100 text-red-700 border-red-400";
  }
  if (colorLower.includes("yellow") && colorLower.includes("red")) {
    return "bg-gradient-to-r from-yellow-100 to-red-100 text-yellow-700 border-yellow-400";
  }
  
  // Fallback to single color detection
  if (colorLower.includes("yellow")) return colorStyles["Yellow"];
  if (colorLower.includes("red")) return colorStyles["Red"];
  if (colorLower.includes("blue")) return colorStyles["Blue"];
  if (colorLower.includes("green")) return colorStyles["Green"];
  
  return colorStyles["-"];
};

export default function SwimLevelBadge({ color, size = "default", compact = false, className }) {
  const sizeClasses = {
    sm: "text-xs px-2 py-0.5",
    default: compact ? "text-xs px-2 py-0.5" : "text-sm px-3 py-1",
    lg: "text-base px-4 py-1.5",
  };

  const displayColor = color || "-";
  
  // Compact mode shows abbreviated text
  const getDisplayText = () => {
    if (color === "-" || !color) return "—";
    if (compact) {
      const colorLower = color.toLowerCase();
      if (colorLower.includes("yellow") && colorLower.includes("blue")) return "Y/B";
      if (colorLower.includes("red") && colorLower.includes("blue")) return "R/B";
      if (colorLower.includes("green") && colorLower.includes("blue")) return "G/B";
      if (colorLower === "yellow") return "Y";
      if (colorLower === "red") return "R";
      if (colorLower === "blue") return "B";
      if (colorLower === "green") return "G";
    }
    return color;
  };

  return (
    <Badge
      className={cn(
        getColorStyle(displayColor),
        sizeClasses[size],
        "font-medium border",
        className
      )}
      data-testid={`swim-badge-${displayColor?.toLowerCase().replace(/\s+/g, '-')}`}
    >
      {getDisplayText()}
    </Badge>
  );
}
